/* eslint-disable react/no-direct-mutation-state */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Input } from 'reactstrap';
import { BsCashStack } from "react-icons/bs"
import { BsCreditCard2Back } from "react-icons/bs"
import Spinner from "react-spinners/ScaleLoader";
import PaymentComponent from "../payments/paymentComponent";
import OrderConfirmation from "../confirmation/orderConfirmation";


const basketApiProxy = require('../../../../utils/api/basketApiProxy.js');
const stateManager = require('../../../../utils/state/stateManager');
const formatter = require('../../../../utils/formatter/formatter');
const stringUtil = require('../../../../utils/string/stringUtil');
const viewUtil = require('../../../../utils/view/viewUtil');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const basketUtil = require('../../../../utils/basket/basketUtil');
const localizationUtils = require('../../../../utils/localization/localizationUtils');
const constants = require('../../../../utils/domain/constants');
const currentComponentAction = require('../../../../utils/state/actions/component/currentComponentAction');

class BasketDetails extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};

        this.state.haltFurtherEnrichmentRequests = false;
        this.state.processingMessage = null;

        this.state.showCreditCardPaymentComponent = false;
        this.state.showConfirmationComponent = false;
    }

    render()
    {
        var state = stateManager.getStore().getState();

        if (this.state.showCreditCardPaymentComponent)
            return this.renderCreditCardPaymentComponent();

        if (this.state.showConfirmationComponent)
            return this.renderConfirmationComponent();

        return <Modal isOpen={true} centered size="lg" style={{ marginBottom: '30px', maxWidth: '600px' }}>
            <div className='AppBar'>
                <table style={{ width: '100%' }}>
                    <tr>
                        <td style={{ width: '99%' }}>
                            <div style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '5px' }}>
                                Order Details &nbsp;&nbsp;|&nbsp;&nbsp;{state.basket.order.dispatchType}
                            </div>

                        </td>
                    </tr>
                </table>
            </div>

            {this.renderBasketDetails()}
            {this.renderProcessingDialogue()}
        </Modal>
    }

    renderBasketDetails()
    {
        if (basketUtil.isBasketEmpty())
        {
            return <div style={{ overflowY: 'scroll', maxHeight: `75vh`, }}>
                <div style={{ marginTop: '30px', marginBottom: '30px', textAlign: 'center' }}>
                    Your basket is empty
                </div>
            </div>
        }

        this.enrichBasket();

        return <div>
            <div style={{ overflowY: 'scroll', maxHeight: `75vh`, }}>
                <div style={{ marginLeft: '15px', marginRight: '15px' }}>

                    <div>
                        {this.renderOrders()}
                    </div>

                    <div>
                        <hr style={{ marginTop: '10px', marginBottom: '0px' }} />
                    </div>

                    <div>
                        {this.renderPriceWidget()}
                    </div>

                    <div>
                        <hr style={{ marginTop: '10px', marginBottom: '0px' }} />
                    </div>

                    <div>
                        {
                            !stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment) ? this.renderPaymentMethod() : null
                        }
                    </div>

                </div>
            </div>
            <div style={{ marginTop: '30px', marginBottom: '10px', textAlign: 'center' }}>
                {this.renderProceedToPaymentButton()}
            </div>
        </div>
    }

    renderOrders()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var components = [];

        for (var index = 0; index < basket.order.saleItems.length; index++)
        {
            components.push(this.renderItem(basket.order.saleItems[index]));
        }

        return <div style={{ marginTop: '30px' }}>
            {components}
        </div>
    }

    renderItem(saleItem)
    {
        var components = [];

        components.push(
            <tr>
                <td style={{ width: '5%', whiteSpace: 'nowrap', verticalAlign: 'middle', textAlign: 'left' }}>
                    {saleItem.quantity}
                </td>
                <td style={{ fontWeight: 'bold', verticalAlign: 'middle', textAlign: 'left' }}>
                    <div style={{ marginLeft: '8px' }}>{saleItem.caption}</div>
                </td>
                <td style={{ width: '10%', textAlign: 'right' }}></td>
                <td style={{ width: '10%', textAlign: 'right' }}></td>
                <td style={{ width: '20%', whiteSpace: 'nowrap', verticalAlign: 'middle', textAlign: 'right' }}>
                    {formatter.convertToCurrencyFormat(saleItem.quantity * saleItem.unitPrice)}
                </td>
            </tr>
        )

        this.renderSubItems(saleItem, components, 8);

        components = <table style={{ width: '100%', tableLayout: 'fixed' }}>{components}</table>
        return <div style={{ marginBottom: '10px' }}>{components}</div>;
    }

    renderSubItems(saleItem, components, margin)
    {
        saleItem.saleItems.forEach(subSaleItem =>
        {
            var priceComponent = <div>&nbsp;</div>
            if (subSaleItem.unitPrice > 0)
            {
                priceComponent = formatter.convertToCurrencyFormat(subSaleItem.quantity * subSaleItem.unitPrice);
            }
            components.push(
                <tr>
                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', textAlign: 'left' }}>
                        &nbsp;
                    </td>
                    <td style={{ verticalAlign: 'middle', textAlign: 'left' }}>
                        <div style={{ marginLeft: `${margin}px` }}>{stringUtil.trimString(subSaleItem.caption)}</div>
                    </td>
                    <td>
                        &nbsp;
                    </td>
                    <td>
                        &nbsp;
                    </td>
                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', textAlign: 'right' }}>
                        {priceComponent}
                    </td>
                </tr>
            );
            this.renderSubItems(subSaleItem, components, margin + 5);
        })
    }

    renderPriceWidget()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var components = [];
        components.push(<tr>
            <td style={{ width: '99%' }}>
                Total Order Price
            </td>
            <td style={{ whiteSpace: 'nowrap', paddingLeft: '20px' }}>
                {formatter.convertToCurrencyFormat(basketUtil.getTotalOrderPrice())}
            </td>
        </tr>);

        components.push(<tr>
            <td style={{ width: '99%' }}>
                Discount
            </td>
            <td style={{ whiteSpace: 'nowrap', paddingLeft: '20px' }}>
                {formatter.convertToCurrencyFormat(basketUtil.getTotalDiscounts())}
            </td>
        </tr>);

        components.push(<tr>
            <td style={{ width: '99%' }}>
                Charges
            </td>
            <td style={{ whiteSpace: 'nowrap', paddingLeft: '20px' }}>
                {formatter.convertToCurrencyFormat(basketUtil.getTotalCharges())}
            </td>
        </tr>);

        if (!localizationUtils.isVatInclusive() && localizationUtils.isVatApplicable())
        {
            components.push(<tr>
                <td style={{ width: '99%' }}>
                    {localizationUtils.getVatCaption()}
                </td>
                <td style={{ whiteSpace: 'nowrap', paddingLeft: '20px' }}>
                    {formatter.convertToCurrencyFormat(basketUtil.getTotalVat())}
                </td>
            </tr>);
        }

        components.push(<tr>
            <td style={{ width: '99%', fontWeight: 'bold' }}>
                Total Sale Price
            </td>
            <td style={{ whiteSpace: 'nowrap', paddingLeft: '20px', fontWeight: 'bold' }}>
                {formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}
            </td>
        </tr>);

        return <div style={{ marginTop: '30px' }}>
            <table style={{ width: '100%' }}>
                {components}
            </table>
        </div>


    }

    renderProceedToPaymentButton()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        return <Button color="primary"
            style={{
                color: `var(--button-addToBasket-font-color)`,
                background: `var(--button-addToBasket-background-color)`,
                borderColor: `var(--button-addToBasket-background-color)`,
                fontSize: `var(--button-addToBasket-font-size)`,
                fontWeight: 'bold',
                marginRight: '5px',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '10px',
                paddingBottom: '10px',
                width: '80%',
                borderRadius: 15
            }}
            disabled={basketUtil.isBasketEmpty() || basket.doRequireEnrichment || stringUtil.isStringNullOrEmpty(basket.order.paymentMethod)}
            onClick={async () =>
            {
                this.onPaymentButtonClick();
            }}>Proceed To Payment - {formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}</Button>
    }

    renderPaymentMethod()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var dispatchTypeConfiguration = state.allowedDispatchTypes.find(d => d.dispatchType == basket.order.dispatchType);

        return <div style={{ marginTop: '30px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>How would you like to pay</div>
            <div className="invisible-scrollbar" style={{ display: 'flex', flexDirection: 'row', overflowX: 'auto' }}>

                {this.renderPaymentMethodWidget("Cash", "Pay At Store",
                    dispatchTypeConfiguration.paymentMethods.find(pm => stringUtil.areStringSame(pm, "Cash")) == null,
                    stringUtil.areStringSame(basket.order.paymentMethod, "Cash"),
                    <BsCashStack size={30} />)}

                {this.renderPaymentMethodWidget("Credit", "Credit Card",
                    dispatchTypeConfiguration.paymentMethods.find(pm => stringUtil.areStringSame(pm, "Credit")) == null,
                    stringUtil.areStringSame(basket.order.paymentMethod, "Credit"),
                    <BsCreditCard2Back size={30} />)}
            </div>
        </div>
    }

    renderPaymentMethodWidget(paymentMethod, caption, disabled, isSelected, iconComponent)
    {
        var background = null;
        if (disabled)
            background = '#E0E0E0';

        var className = "";
        if (isSelected)
            className = "selectedPaymentMethod";
        else
            className = "paymentMethod";


        var state = stateManager.getStore().getState();
        var basket = state.basket;

        return <div className={className} style={{ background: background, marginRight: '10px', border: `var(--menu-item-border)`, padding: '10px' }}
            onClick={() =>
            {
                if (disabled)
                    return;

                basket.order.paymentMethod = paymentMethod;
                this.setState({});
            }}>
            <table>
                <tr>
                    <td style={{ textAlign: 'center' }}>
                        {iconComponent}
                    </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                        <div className='smallText' style={{ textAlign: 'center' }}>{caption}</div>
                    </td>
                </tr>
            </table>
        </div>;
    }

    enrichBasket()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        if (!basket.doRequireEnrichment || this.state.haltFurtherEnrichmentRequests)
            return null;

        this.state.processingMessage = "Enriching your basket";

        var originalVoucherCode = basket.voucherCode;
        basketApiProxy.enrichBasket()
            .then(messages =>
            {
                basket.doRequireEnrichment = false;
                var errorMessage = messages.find(m => stringUtil.areStringSame(m.type, "error"));

                viewUtil.clearErrors();
                if (errorMessage != null)
                {
                    basket.voucherCode = originalVoucherCode;
                    basket.doRequireEnrichment = true;
                    this.state.haltFurtherEnrichmentRequests = true;
                    viewUtil.showErrorAlert(errorMessage.message)
                }

                this.state.processingMessage = null;
                this.setState({});
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });

    }

    renderProcessingDialogue()
    {
        if (this.state.processingMessage == null)
            return;

        return <Modal isOpen={true} centered>
            <div style={{ margin: '50px 10px' }}>
                <div style={{ textAlign: 'center', whiteSpace: 'nowrap', marginBottom: '10px' }}>
                    {this.state.processingMessage}
                </div>
                <div style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                    <Spinner color={`var(--spinner-color)`} size={40} />
                </div>
            </div>
        </Modal>
    }

    async onPaymentButtonClick()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        if (stringUtil.areStringSame(basket.order.paymentMethod, "Cash"))
        {
            this.placeOrder();
            return;
        }

        this.state.showCreditCardPaymentComponent = true;
        this.setState({});
    }

    async placeOrder()
    {
        this.state.processingMessage = "Sending Order To Kitchen";
        this.setState({});

        try
        {
            await basketUtil.submitOrder();
            this.state.showConfirmationComponent = true;
            this.setState({});
        }
        catch (error)
        {
            viewUtil.showErrorAlert(error.message);
            stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
        }
        finally
        {
            this.state.processingMessage = null;
            this.setState({});
        }
    }

    renderCreditCardPaymentComponent()
    {
        if (!this.state.showCreditCardPaymentComponent)
            return;

        return <PaymentComponent amount={basketUtil.getTotalBasketPrice()} onDismiss={() =>
        {
            this.state.showCreditCardPaymentComponent = false;
            this.setState({});
        }} />
    }

    renderConfirmationComponent()
    {
        if (!this.state.showConfirmationComponent)
            return;

        if (stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment))
        {
            const store = stateManager.getStore();
            store.dispatch(currentComponentAction.createAction("confirmation"));
        }
        else
        {
            return <OrderConfirmation
                onClose={() =>
                {
                    basketUtil.resetBasket();
                    stateManager.getStore().getState().user = null;
                    this.props.onDismiss();
                }} />
        }
    }
}

const mapStateToProps = state => 
{
    return {
        basketVersion: state.basketVersion,
    }
}

export default connect(mapStateToProps)(BasketDetails)